export default __webpack_public_path__ + "static/media/nft_4.283a9fc4.jfif";